import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import { Pagination } from '@utils/models/Pagination';
import { useQuery } from 'react-query';
import { NumberParam, StringParam, useQueryParam, useQueryParams, withDefault } from 'use-query-params';

import { AIAgentFilterType } from '../models';

export function useAIAgentFilter(size: number) {
  const [search] = useQueryParam('text', withDefault(StringParam, ''));
  const [query] = useQueryParams({
    page: withDefault(NumberParam, 1)
  });

  const { page } = query;

  return useQuery<Pagination<AIAgentFilterType>>({
    queryKey: ['ai-agents-filter', search, page, size],
    queryFn: async () => {
      const res = await $api.post(`/v1/chat-flow/filter`, {
        ...(search && { text: search }),
        page: page || 1,
        size: size || 10
      });

      const data: Pagination<AIAgentFilterType> = res?.data?.data;

      return data
        ? {
            ...data,
            data: data?.data?.map(item => ({
              ...item,
              createdDate: timeStampToDate({ date: item?.createdDate, timeStamp: item?.createdTimestamp }),
              updatedDate: timeStampToDate({ date: item?.updatedDate, timeStamp: item?.updatedTimestamp })
            }))
          }
        : data;
    }
  });
}
